import PropTypes from 'prop-types'
import React from 'react'

import { PictureWrapper, DynamicImageStyled } from './styles'

const DHowFirstRussianBox = ({ path }) => (
  <PictureWrapper className="my-4 my-md-0">
    <DynamicImageStyled
      image={`${path}/dna-flying`}
      imageType="png"
      imageSizes={{ xs: 500, md: 600, lg: 900 }}
      fitOption="contain"
      alt={'Генетический тест'}
    />
  </PictureWrapper>
)

DHowFirstRussianBox.propTypes = {
  path: PropTypes.string.isRequired,
}

export default DHowFirstRussianBox
